export default "__VITE_ASSET__DBHg3jx5__"